var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.67453 0.286876C5.86178 0.12638 6.13808 0.12638 6.32532 0.286876L10.992 4.28688C11.2017 4.46659 11.2259 4.78224 11.0462 4.9919C10.8665 5.20156 10.5509 5.22584 10.3412 5.04613L5.99993 1.32504L1.65866 5.04613C1.44899 5.22584 1.13334 5.20156 0.953633 4.9919C0.773922 4.78224 0.798202 4.46659 1.00787 4.28688L5.67453 0.286876ZM1.00787 6.95354L5.67453 2.95354C5.86178 2.79305 6.13808 2.79305 6.32532 2.95354L10.992 6.95354C11.2017 7.13325 11.2259 7.4489 11.0462 7.65857C10.8665 7.86823 10.5509 7.89251 10.3412 7.7128L5.99993 3.99171L1.65866 7.7128C1.44899 7.89251 1.13334 7.86823 0.953633 7.65857C0.773922 7.4489 0.798202 7.13325 1.00787 6.95354Z",
    fill: "#E43939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleUp);
export default __webpack_public_path__ + "static/media/double-up.2b7d5bf4ac376e1fed4f4257b9e19af0.svg";
export { ForwardRef as ReactComponent };